import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';

export const CustomModalBody = styled(Column)`
  width: 440px;
  height: 280px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 10px 40px ${({ theme }): string => theme.colors.boxShadowDarker};
`;

export const IconWrapper = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  height: 64px;
  width: 64px;
  padding-bottom: 20px;
`;
